
import { ScreenReaderContent } from "@instructure/ui-a11y-content";
import { Heading } from "@instructure/ui-heading";
import { IconEditLine } from "@instructure/ui-icons";
import React, { Component } from "react";

import styles from "./styles.module.scss";

interface ProfileHeaderProps {
    username: string;
    avatar: string;
    onAvatarChange?: (newAvatar) => void;
}

export class ProfileHeader extends Component<ProfileHeaderProps> {
    render() {
        return <div className={styles.wrapper}>
            {this.props.onAvatarChange ? <>
                <a className={styles.avatar} style={{ backgroundImage: `url(${this.props.avatar})` }} href="#" title="Click to change profile pic" onClick={this.props.onAvatarChange}>
                    <ScreenReaderContent>
                        Click to change profile picture for {this.props.username}
                    </ScreenReaderContent>
                    <span className={styles['edit-icon']}>
                        <IconEditLine />
                    </span>
                </a>
            </> : <>
                <span className={styles.avatar} style={{ backgroundImage: `url(${this.props.avatar})` }} />
            </>}
            <Heading margin="xx-small 0 0 small" color="primary">{this.props.username}</Heading>
        </div>
    }
}
